module.exports = __webpack_public_path__ + "/static/assets/dba629c24296756d68a135988fe96011.svg";